<template>
  <vs-popup :active.sync="isActive" id="lossReasonPopup">
    <vs-row vs-type="flex" vs-w="12" class="p-0 m-0">
      <vs-button
        size="large"
        color="transparent"
        class="payment-label bg-primary2 text-white w-full"
      >
        Zayiat Oluştur
      </vs-button>
    </vs-row>
    <vs-row vs-type="flex" vs-w="12" class="p-5">
      <vs-row vs-type="flex" vs-w="12" vs-align="center">
        <v-select
          v-model="selectedReason"
          name="Zayiat Sebebi"
          class="w-full"
          :options="reasons"
          v-validate="{ required: true }"
          itemid="id"
          label="name"
          placeholder="Zayiat Sebebi Seçiniz"
        />
        <span
          class="text-danger text-xsmaller"
          v-show="errors.has('Zayiat Sebebi')"
          >{{ errors.first("Zayiat Sebebi") }}</span
        >
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" vs-align="center" class="mt-4">
        <vs-textarea
          v-validate="'required|max:200'"
          name="Açıklama"
          v-model="description"
          label="Açıklama"
        />
        <span
          class="text-danger text-xsmaller"
          v-show="errors.has('Açıklama')"
          >{{ errors.first("Açıklama") }}</span
        >
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" vs-align="center">
        <vs-col
          vs-type="flex"
          vs-w="6"
          class="px-2"
          vs-justify="center"
          vs-align="center"
        >
          <vs-button color="danger" @click="isActive = false">
            Vazgeç
          </vs-button>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-w="6"
          class="px-2"
          vs-justify="center"
          vs-align="center"
        >
          <vs-button color="success" @click="submitLoss"> Onayla </vs-button>
        </vs-col>
      </vs-row>
    </vs-row>
  </vs-popup>
</template>

<script>
import { getLossReasons } from "@/api/LossReason.js";
import { createStockLoss, createNewLoss } from "@/api/Loss.js";
export default {
  data() {
    return {
      isActive: false,
      reasons: [],
      selectedReason: null,
      description: null,
      lossData: null,
    };
  },
  computed: {
    activePersonel: function () {
      return this.$store.getters["selfservice/getActivePersonal"];
    },
  },
  methods: {
    submitLoss: async function () {
      console.log(this.lossData);
      let checker = await this.$validator.validateAll();
      if (!checker) return;
      this.lossData.lossReason = this.selectedReason;
      this.lossData.description = this.description;
      this.lossData.userId =
        this.activePersonel != null ? this.activePersonel.id : 0;
      if (this.lossData.type == "Product") {
        this.isActive = false;
        createNewLoss(this.lossData)
          .then((res) => {
            if (res && res.status == 200) {
              this.$vs.notify({
                color: "success",
                title: "Başarılı !",
                text: "Zayiat Oluşturuldu !",
              });
              this.$emit("done");
            } else {
              this.$fire({
                title: "Hata : " + res.status,
                text: "Zayiat Oluşturulamadı !",
                type: "error",
              });
              this.$vs.notify({
                color: "danger",
                title: "Hata : " + res.status,
                text: "Zayiat Oluşturulamadı !",
              });
            }
          })
          .catch((error) => {
            this.$fire({
              title: "Hata !",
              text: "Sunucu Bağlantı Hatası  !",
              type: "error",
            });
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: "Sunucu Bağlantı Hatası  !",
            });
          });
      } else if (this.lossData.type == "Stock") {
        this.lossData.stockEntries.forEach((x) => {
          x.quantity = parseFloat(x.quantity);
        });
        createStockLoss(this.lossData)
          .then((res) => {
            if (res && res.status == 200) {
              this.$vs.notify({
                color: "success",
                title: "Başarılı",
                text: "Zayiat Oluşturuldu !",
              });
              this.isActive = false;
              this.$emit("done");
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Hata : " + res.status,
                text: "Zayiat Oluşturulamadı !",
              });
            }
          })
          .catch((error) => {
            this.$fire({
              title: "Hata !",
              text: "Sunucu Bağlantı Hatası  !",
              type: "error",
            });
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: "Sunucu Bağlantı Hatası !",
            });
          });
      }
    },
    getLossReasons() {
      if (this.reasons.length > 0) return;
      getLossReasons()
        .then((res) => {
          if (res && res.status == 200) {
            this.reasons = res.data;
          } else {
            this.$fire({
              title: "Hata : " + res.status,
              text: "Zayiat Sebepleri Yüklenemedi !",
              type: "error",
            });
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Zayiat Sebepleri Yüklenemedi !",
            });
          }
        })
        .catch((error) => {
          this.$fire({
            title: "Hata",
            text: "Sunucu Bağlantı Hatası !",
            type: "error",
          });
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
  },
  watch: {
    isActive(val) {
      if (!val) {
        this.$validator.reset();
        this.selectedReason = null;
        this.description = null;
        this.lossData = null;
      } else {
        this.getLossReasons();
      }
    },
  },
};
</script>

<style>
#lossReasonPopup .vs-popup .vs-popup--header {
  display: none;
}

#lossReasonPopup .vs-popup .vs-popup--content {
  padding: 0 !important;
  margin: 0 !important;
  width: 100%;
}

#lossReasonPopup .vs-popup {
  border-radius: 2rem !important;
}
.swal2-container {
  z-index: 99999;
}
</style>
